import { FormProvider, Controller } from 'react-hook-form';
import { Button, } from '../../components';
import { Accordion } from '../../components/atoms/Accordion';
import { Text } from '@eo-locale/react';
import { Checkbox } from '../../components/atoms/Checkbox';
import { useAgreements } from './useAgreements';
import { agreementsMap } from '../../utils/agreementsMap';

export const Agreements = () => {

    const {
        methods,
        handleSubmit,
        onSubmit,
        requiredAgreements,
        optionalAgreements,
        isSubmitting
    } = useAgreements();

    return <FormProvider {...methods}>
        <form className='px-[8px] xl:px-4 min-h-screen' onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
                <div className="space-y-4">
                    <h3 className="text-[18px] leading-[22px] font-medium mb-2 mx-2">Zgody wymagane:</h3>
                    {requiredAgreements.map((agreement, index) => {
                        const Component = agreementsMap?.[agreement?.name] ?? null;
                        return (
                            <Accordion
                                key={agreement.id}
                                title={
                                    <div className="flex gap-2 items-center">
                                        <Controller
                                            name={`agreements.${index}.has_agree`}
                                            control={methods.control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    disabled
                                                    type="checkbox"
                                                    id={`agreement-${agreement.id}`}
                                                    checked={Boolean(field.value)}
                                                    onChange={(e) =>
                                                        field.onChange(e.target.checked)
                                                    }
                                                />
                                            )}
                                        />
                                        <div>
                                            <label
                                                htmlFor={`agreement-${agreement.id}`}
                                                className="font-medium cursor-pointer"
                                            >
                                                {agreement.name}
                                            </label>
                                        </div>
                                    </div>
                                }
                            >
                                <div className="p-4 text-[black] rounded-b-lg">
                                    <Component />
                                </div>
                            </Accordion>
                        );
                    })}
                </div>
                <div className="space-y-4 mt-4">
                    <h3 className="text-[18px] leading-[22px] font-medium mb-2 mx-2">Zgody dodatkowe:</h3>
                    {optionalAgreements.map((agreement, index) => {
                        const Component = agreementsMap?.[agreement?.name] ?? null;

                        return (
                            <Accordion
                                key={agreement.id}
                                title={
                                    <div className="flex gap-2 items-center">
                                        <Controller
                                            name={`agreements.${requiredAgreements.length + index}.has_agree`}
                                            control={methods.control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    type="checkbox"
                                                    id={`agreement-${agreement.id}`}
                                                    checked={Boolean(field.value)}
                                                    onChange={(e) =>
                                                        field.onChange(e.target.checked)
                                                    }
                                                />
                                            )}
                                        />
                                        <div>
                                            <label
                                                htmlFor={`agreement-${agreement.id}`}
                                                className="font-medium cursor-pointer"
                                            >
                                                {agreement.name}
                                            </label>
                                        </div>
                                    </div>
                                }
                            >
                                <div className="p-4 text-[black] rounded-b-lg">
                                    <Component />
                                </div>
                            </Accordion>
                        );
                    })}
                </div>
                <div className="w-full flex justify-center">
                    <Button
                        type="submit"
                        className="mt-4 btn mx-auto btn-primary"
                        disabled={isSubmitting}
                    >
                        <Text id="save" />
                    </Button>
                </div>
            </div>
        </form>
    </FormProvider>
};
